import React from 'react'

import { Button } from '../../components/ui/button'
import { BotIcon, Loader2Icon, UserIcon, Star } from 'lucide-react'

import { decodeBase64Image } from '../../components/_utils/decodeBase64Image'

type MessageProps = {
	index?: number
	message?: any
	loading?: boolean
	showSteps?: boolean,
	isLatestMessage?: boolean;
	input: string,
	isFavorite: boolean,
	handleCreateSteps: (prompt: string) => void
	handleFavorites: (prompt: string, isFavorite: boolean) => void
	onImageClick: (imageUrl: string) => void
}

export default function Message({
	index = 0,
	message = '',
	loading = false,
	showSteps,
	isLatestMessage,
	input,
	isFavorite,
	handleCreateSteps,
	handleFavorites,
	onImageClick
}: MessageProps) {
	const isUser = index % 2 === 0
	const baseStyles = 'relative mb-12 rounded-2xl border p-6 pb-12'
	const botStyles =
		'absolute -bottom-6 left-4 flex aspect-square w-12 items-center justify-center rounded-2xl bg-blue-500 text-white'	

	if (loading) {
		return (
			<div className={baseStyles}>
				<div className="flex items-center space-x-2 pb-4">
					<Loader2Icon size={16} className="animate-spin" />
					<p className="text-muted-foreground">Hold on, I&apos;m thinking...</p>
				</div>
				<div className={botStyles}>
					<BotIcon />
				</div>
			</div>
		)
	}

	const onClickFavorite = (prompt: string) => {
		//to-do: add simple animation for button
		handleFavorites(prompt, isFavorite)
	}
	
	if (isUser) {
		return (
			<div className={baseStyles}>
				<div className="w-full flex justify-between gap-4">
					<p className="break-words">{message}</p>
					<button className="" onClick={() => onClickFavorite(message)} disabled={loading}>
						{isFavorite ? <Star stroke="black" fill="yellow" size={20}/> : <Star size={20}/>}
					</button>
				</div>
				<div className="absolute -bottom-6 right-4 flex aspect-square w-12 items-center justify-center rounded-2xl bg-primary text-white">
					<UserIcon />
				</div>
			</div>
		)
	}

	const { image: imageString = '', message: text = '' } = JSON.parse(JSON.stringify(message));
	const decodedImage = decodeBase64Image(imageString);

	const onSendMessageSteps = async (message: string) => {
		handleCreateSteps(message)
	}

	const onClickImage = () => {
    	onImageClick(decodedImage);
  	};

	return (
		<div className={baseStyles}>
			<p className="whitespace-pre-line">{text.trim()}</p>
			{imageString ? (
				<img className="h-auto max-w-md" src={decodedImage} alt="API response image" onClick={onClickImage} style={{ cursor: 'pointer' }}/>
			) : null}
			<div className={botStyles}>
				<BotIcon />
			</div>
			{showSteps && isLatestMessage && (
				<Button
					onClick={() => onSendMessageSteps(input)}
					size="icon"
					variant="default"
					className="absolute right-8 h-8 w-28" 
				>
					Show Steps
				</Button>
			)}
		</div>
	)
}